import {isPlatformBrowser} from '@angular/common';
import {Component, HostListener, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-rp-header',
  templateUrl: './rp-header.component.html',
  styleUrls: ['./rp-header.component.scss'],
})
export class RpHeaderComponent implements OnInit {
  currentLang = 'en';
  mobileMenuOpen = false;
  langNames: Record<string, string> = { en: 'English', ar: 'العربية' };

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private translateService: TranslateService,
  ) {
  }

  ngOnInit(): void {
    this.currentLang = this.translateService.currentLang || 'en';
  }


  switchLanguage(): void {
    const lang = this.currentLang === 'en' ? 'ar' : 'en';
    this.translateService.use(lang);
    this.currentLang = lang;
    if (isPlatformBrowser(this.platformId)) {
      document.documentElement.lang = lang;
      document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    }
  }

  getSignupUrl(): string {
    const subdomain = environment.server === 'dev' ? 'dev' : 'app';
    return `https://${subdomain}.uptal.com/register?type=recruiter-program`;
  }
}
